import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { isIBQueued } from '../models/ib-queues-calls-chat-data';
import { ChatMessage } from '../models';

@Component({
  selector: 'lib-ibqueued-calls-message',
  templateUrl: './ibqueued-calls-message.component.html',
  styles: [
    `
      .extra-small {
        font-size: 60%;
      }

      .total-row {
        border-top: 2px solid black !important;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IBQueuedCallsMessageComponent {
  @Input() msg!: ChatMessage;
  isIBQueued = isIBQueued;

  constructor() {}
}
